/* 然 -ZEN- スクロール表示（.zen-reveal → .zen-in）。
   Shopify のテーマエディタ編集時（designMode）は即表示にして編集を妨げない。 */
(function () {
  function reveal(root) {
    var els = (root || document).querySelectorAll('.zen-reveal:not(.zen-in)');
    if (!els.length) return;
    if (window.Shopify && window.Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('zen-in'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('zen-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('zen-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () { reveal(document); });
  // テーマエディタでセクション追加/再描画時にも適用
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();

/* Lenis 慣性スクロール（気持ちの良い減速つきスクロール）。
   - prefers-reduced-motion 時は無効（アクセシビリティ配慮）
   - テーマエディタ（designMode）では無効（編集操作を妨げない）
   - ホイールのみスムーズ化（タッチは端末ネイティブを尊重） */
(function () {
  if (!('Lenis' in window)) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var lenis = new window.Lenis({
    duration: 1.1,
    easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
    smoothWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 1.6
  });
  window.lenis = lenis;

  function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
  requestAnimationFrame(raf);

  // ページ内アンカー（#id / /path#id）を Lenis でなめらかにスクロール
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var hash = href.indexOf('#') >= 0 ? href.slice(href.indexOf('#')) : '';
    if (hash.length < 2) return;
    // 別ページへのリンク（現在のパスと異なる）は通常遷移に任せる
    var path = href.split('#')[0];
    if (path && path !== window.location.pathname && path !== '/' + window.location.pathname && !path.startsWith('#')) return;
    var target = document.querySelector(hash);
    if (!target) return;
    e.preventDefault();
    lenis.scrollTo(target, { offset: -80, duration: 1.2 });
    if (history.replaceState) history.replaceState(null, '', hash);
  });
})();

/* トップページ: スクロールでヘッダーを白背景・上部固定に切り替え */
(function () {
  function init() {
    var body = document.body;
    if (!body || !body.classList.contains('zen-home')) return;
    function onScroll() {
      body.classList.toggle('zen-scrolled', window.scrollY > 40);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ページ先頭へ戻るボタン。
   - 一定量スクロールでふわっと表示、最上部付近でふわっと非表示
   - クリックで最上部へ（Lenis があれば慣性つき、無ければネイティブ smooth） */
(function () {
  function init() {
    var btn = document.querySelector('.zen-totop');
    if (!btn) return;
    var SHOW_AT = 400; // これより下へスクロールしたら表示
    function onScroll() {
      btn.classList.toggle('zen-totop--on', window.scrollY > SHOW_AT);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    btn.addEventListener('click', function () {
      if (window.lenis && !reduce) {
        window.lenis.scrollTo(0, { duration: 1.2 });
      } else {
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* よくある質問アコーディオンの滑らかな開閉。
   ネイティブ <details> は即時トグルなので、Web Animations API で
   details の高さ＋本文のフェードをアニメーションさせる（実績のある手法）。
   - prefers-reduced-motion 時はネイティブの即時トグルに任せる
   - WAAPI 非対応環境もネイティブ動作にフォールバック */
(function () {
  var DUR_OPEN = 360, DUR_CLOSE = 300, EASE = 'cubic-bezier(.2,.6,.2,1)';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Accordion(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.zen-faq-body');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    if (!this.summary || !this.content) return;
    var self = this;
    this.summary.addEventListener('click', function (e) { self.onClick(e); });
    el.dataset.zenAcc = '1';
  }
  Accordion.prototype.onClick = function (e) {
    if (reduce) return; // 動き控えめ設定時はネイティブの即時トグル
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) this.expandOpen();
    else if (this.isExpanding || this.el.open) this.shrink();
  };
  Accordion.prototype.shrink = function () {
    var self = this;
    this.isClosing = true;
    this.el.classList.add('zen-closing'); // アイコンを閉じ向きへ同期
    var start = this.el.offsetHeight, end = this.summary.offsetHeight;
    if (this.animation) this.animation.cancel();
    this.content.animate(
      { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-6px)'] },
      { duration: DUR_CLOSE, easing: EASE }
    );
    this.animation = this.el.animate({ height: [start + 'px', end + 'px'] }, { duration: DUR_CLOSE, easing: EASE });
    this.animation.onfinish = function () { self.finish(false); };
    this.animation.oncancel = function () { self.isClosing = false; };
  };
  Accordion.prototype.expandOpen = function () {
    this.el.classList.remove('zen-closing');
    this.el.style.height = this.el.offsetHeight + 'px';
    this.el.open = true;
    var self = this;
    window.requestAnimationFrame(function () { self.expand(); });
  };
  Accordion.prototype.expand = function () {
    var self = this;
    this.isExpanding = true;
    var start = this.el.offsetHeight, end = this.summary.offsetHeight + this.content.offsetHeight;
    if (this.animation) this.animation.cancel();
    this.content.animate(
      { opacity: [0, 1], transform: ['translateY(-6px)', 'translateY(0)'] },
      { duration: DUR_OPEN, easing: EASE }
    );
    this.animation = this.el.animate({ height: [start + 'px', end + 'px'] }, { duration: DUR_OPEN, easing: EASE });
    this.animation.onfinish = function () { self.finish(true); };
    this.animation.oncancel = function () { self.isExpanding = false; };
  };
  Accordion.prototype.finish = function (open) {
    this.el.open = open;
    this.el.classList.remove('zen-closing');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = '';
    this.el.style.overflow = '';
  };

  function init(root) {
    (root || document).querySelectorAll('.zen-faq-item').forEach(function (el) {
      if (el.dataset.zenAcc) return;
      if (typeof el.animate !== 'function') return; // WAAPI 非対応はネイティブのまま
      new Accordion(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* 然 -ZEN- FAQ カテゴリタブ。
   矢印キーでの移動と Home/End に対応し、選択中のタブだけをタブ順に残す。
   テーマエディタでブロックを選択したときは、その質問を含むタブへ自動で切り替える。 */
(function () {
  function setup(root) {
    (root || document).querySelectorAll('.zen-faqtabs').forEach(function (sec) {
      if (sec.dataset.zenTabsReady) return;
      sec.dataset.zenTabsReady = '1';
      var tabs = Array.prototype.slice.call(sec.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      function activate(tab, focus) {
        tabs.forEach(function (t) {
          var selected = t === tab;
          t.setAttribute('aria-selected', selected ? 'true' : 'false');
          if (selected) { t.removeAttribute('tabindex'); } else { t.setAttribute('tabindex', '-1'); }
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) { panel.hidden = !selected; }
        });
        if (focus) tab.focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') next = tabs[0];
          else if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); activate(next, true); }
        });
      });

      sec.zenActivateByPanel = function (panel) {
        var tab = tabs.filter(function (t) { return t.getAttribute('aria-controls') === panel.id; })[0];
        if (tab) activate(tab, false);
      };
    });
  }

  document.addEventListener('DOMContentLoaded', function () { setup(document); });
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest('.zen-faqtabs-panel');
    var sec = e.target.closest('.zen-faqtabs');
    if (panel && sec && sec.zenActivateByPanel) sec.zenActivateByPanel(panel);
  });
})();
